import { SELECIONAR_VIAGEM_VOLTA } from '../../actions/types'

const initialState = null

export default function reducerViagemVolta (state = initialState, action) {
  switch (action.type) {
    case SELECIONAR_VIAGEM_VOLTA: {
      if (!action.payload || action.payload.selecionada) {
        return initialState
      }
      return action.payload;
    }

    default: {
      return state
    }
  }
}
